module.exports = __webpack_public_path__ + "static/img/logo.64e7bc42.png";